import { type ReactNode } from 'react';

type ExternalLegalLinkProps = {
  readonly children?: ReactNode;
  readonly href: string;
};

/**
 * Anchor used inside `<Trans>` bodies; the link text is injected as children
 * from the translation string via the surrounding `<websiteLink>` tag.
 */
export function ExternalLegalLink({ children, href }: ExternalLegalLinkProps) {
  return (
    <a
      className="text-tiga-action-default underline hover:text-tiga-action-darker"
      href={href}
      rel="noreferrer"
      target="_blank"
    >
      {children}
    </a>
  );
}
